import React, { useState } from 'react';
import 'components/commons/error/error.style.scss';

type ErrorProps = {
    message: string;
    time?: number;
}

const Error: React.FC<ErrorProps> = ({ message, time = 5 }): JSX.Element => {

    const [show, setShow] = useState(true);

    setTimeout(() => {
        setShow(false);
    }, time * 1000);

    return (show && time > 0 &&
        <div className='c-error'>
            {message}
        </div>
    )
};

export default Error;
